import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input } from 'dibs-elements/exports/Input';
import SearchIcon from 'dibs-icons/exports/MagnifyingGlass';

import styles from './SbSharedRefineMenuSearchInput.scss';

export function SbSharedRefineMenuSearchInput(props) {
    const {
        autoComplete,
        className,
        horizontalSpacing,
        onInput,
        onSubmit,
        placeholder,
        size,
        value,
    } = props;
    const containerClass = classnames(className);
    return (
        <div className={containerClass}>
            <form onSubmit={onSubmit} action="">
                <Input
                    autoComplete={autoComplete}
                    autoCorrect={false}
                    dataTn="search-input"
                    horizontalSpacing={horizontalSpacing}
                    onChange={onInput}
                    placeholder={placeholder}
                    size={size}
                    spellCheck={false}
                    value={value}
                    rightDecorator={
                        <div className={styles.searchIconWrapper} onClick={onSubmit}>
                            <SearchIcon />
                        </div>
                    }
                />
            </form>
        </div>
    );
}

SbSharedRefineMenuSearchInput.defaultProps = {
    autoComplete: 'off',
    horizontalSpacing: 'medium',
    size: 'medium',
};

SbSharedRefineMenuSearchInput.propTypes = {
    autoComplete: PropTypes.string,
    className: PropTypes.string,
    horizontalSpacing: PropTypes.oneOf(['small', 'medium']),
    onInput: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['medium', 'large']),
    value: PropTypes.string.isRequired,
};
